// extracted by mini-css-extract-plugin
module.exports = {"counter":"char-counter_counter__K6Ovs","warn":"char-counter_warn__aeVMx","full":"char-counter_full__6t45a"};